import React from "react";

const ConfirmModal = ({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
  danger = false,
  children,
}) => (
  <div className="modal-overlay" onClick={onCancel}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      {title && <h3>{title}</h3>}
      {message && <p>{message}</p>}
      {children}
      <div className="modal-actions">
        {cancelLabel !== "" && (
          <button type="button" className="admin-btn secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel || "Cancel"}
          </button>
        )}
        <button
          type="button"
          className={`admin-btn ${danger ? "danger" : ""}`}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Please wait..." : confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
